<template>
  <div>
    <b-modal v-model="showModal" size="sm" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">Enter PIN</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="PIN is required for any changes"
              label-for="pin_verification"
              style="font-size: 12px"
            >
              <input
                v-model="pin_verification"
                v-validate="'required'"
                name="pin_verification"
                data-vv-as="PIN"
                id="pin_verification"
                class="form-control"
                placeholder="PIN"
                maxlength="6"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
              />
            <b-form-invalid-feedback id="input-pin_verification-feedback">{{
              veeErrors.first('pin_verification')
            }}</b-form-invalid-feedback>
            <p style="width: 100%; font-size: 80%;color: #dc3545;">
              {{ error_messages }}
            </p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button variant="light" :disabled="loadingFormPINVerification"
              @click="close()" class="text-primary" block
              size="lg">Cancel</b-button>
          </b-col>
          <b-col>
            <b-button variant="primary" :disabled="loadingFormPINVerification" @click="submit()"
              block size="lg">
              <b-spinner v-if="loadingFormPINVerification"></b-spinner>
              <span v-else>Submit</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: ["showModal"],
  data: function() {
    return {
      pin_verification: "",
      loadingFormPINVerification: false,
      error_messages: "",
    }
  },
  watch: {
    showModal() {
        if(this.showModal) {
          this.pin_verification = "",
          this.error_messages = ""
        }
    }
  },
  methods: {
    close() {
      this.$emit('close-pin-verification');
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loadingFormPINVerification = true;
          const formData = new FormData();
          formData.append("pin_verification", this.pin_verification);
          this.$store
            .dispatch("claimSubmitPINVerification", formData)
            .then((response) => {
              this.loadingFormPINVerification = false;
              this.$emit('after-submit-pin-verification');
            })
            .catch((error) => {
              this.error_messages = error.response ? error.response.data.message : "Failed PIN verification"
              this.loadingFormPINVerification = false;
            });
        }
      });
    }
  }
};
</script>
